import React from 'react';
import ASlider from 'antd-mobile/lib/slider';



export default class Slider extends ASlider {}